import { render, staticRenderFns } from "./FjProductDescription.vue?vue&type=template&id=6d536611&scoped=true&"
import script from "./FjProductDescription.vue?vue&type=script&lang=js&"
export * from "./FjProductDescription.vue?vue&type=script&lang=js&"
import style0 from "./FjProductDescription.vue?vue&type=style&index=0&id=6d536611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d536611",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
